module.exports = {render: function () {with(this){return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 10.9 12.2"}},[_c('title',[_v("back-arrow")]),_c('path',{attrs:{"d":"M6.1 12.2L0 6.1 6.1 0l.2.2L.4 6.1 6.3 12z"}}),_c('path',{attrs:{"d":"M.2 6h10.7v.3H.2z"}})])}}};


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/white-back-arrow.svg
// module id = 436
// module chunks = 1